/**
 * analyticsStats.js — maps /admin/analytics & /owner/analytics
 * response data into StatsGrid stat objects.
 *
 *  Endpoint shape:
 *  { totals: { total_users, total_validations, paid_validations, total_mind_maps },
 *    signupTrend: [{day,count}], validationTrend: [...], mindMappingTrend: [...] }
 */

// number[] sparkline from a [{count}] trend; pads to >=2 points
function spark(trend) {
  const arr = Array.isArray(trend) ? trend.map((t) => Number(t.count) || 0) : [];
  if (arr.length === 0) return [0, 0];
  if (arr.length === 1) return [0, arr[0]];
  return arr;
}

// % change first→last of a trend (null if not computable)
function changePct(trend) {
  const arr = spark(trend);
  const first = arr[0];
  const last = arr[arr.length - 1];
  if (!first || first === 0) return last > 0 ? 100 : null;
  return Math.round(((last - first) / first) * 1000) / 10;
}

export function buildAnalyticsStats(data) {
  if (!data) return [];
  const t = data.totals || {};
  const n = (v) => Number(v) || 0;

  return [
    {
      id: "users",
      label: "Total Users",
      value: n(t.total_users),
      change: changePct(data.signupTrend),
      sparkData: spark(data.signupTrend),
      color: "#C1440E",
      icon: "👥",
      subLabel: "All time",
    },
    {
      id: "validations",
      label: "Idea Validations",
      value: n(t.total_validations),
      change: changePct(data.validationTrend),
      sparkData: spark(data.validationTrend),
      color: "#E5622D",
      icon: "💡",
      subLabel: "All time",
    },
    {
      id: "paid",
      label: "Paid Validations",
      value: n(t.paid_validations),
      change: null,
      sparkData: spark(data.validationTrend),
      color: "#F5A623",
      icon: "💳",
      subLabel: "Converted",
    },
    {
      id: "mindmaps",
      label: "Mind Maps",
      value: n(t.total_mind_maps),
      change: changePct(data.mindMappingTrend),
      sparkData: spark(data.mindMappingTrend),
      color: "#2DD4BF",
      icon: "🗺️",
      subLabel: "All time",
    },
  ];
}
